import { Type } from 'class-transformer';
import { IsInt, IsOptional, Max, Min } from 'class-validator';

export class TopManagerPeriodDto {
  @Type(() => Number)
  @IsInt()
  @Min(2000)
  @Max(2100)
  year: number;

  @Type(() => Number)
  @IsOptional()
  @IsInt()
  @Min(-1)
  @Max(11)
  month?: number;
}

export class TopManagerLeaderDto {
  fullName: string;
}

export class TopManagerDto extends TopManagerLeaderDto {
  totalProfit: number;
}
